import { render, staticRenderFns } from "./JCategoryDictSelect.vue?vue&type=template&id=0674e9a1&style=width%3A%20100%25&"
import script from "./JCategoryDictSelect.vue?vue&type=script&lang=js&"
export * from "./JCategoryDictSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports